import React from 'react';
import { Link } from 'react-router-dom';
import products from '../data/products';

const Home = () => {
  return (
    <div className="w-full">

      {/* 🎥 Local Video Player Section */}
      <div className="relative w-full overflow-hidden bg-black">
        <div className="relative pt-[56.25%]"> {/* 16:9 aspect ratio */}
          <video
            className="absolute top-0 left-0 w-full h-full"
            src="/video.mp4"
            controls
            playsInline
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* 🛒 Featured Products */}
      <div className="p-8 max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Featured Products</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {products.map((product) => (
            <Link to={`/product/${product.slug}`} key={product.id}>
              <div className="border rounded-lg p-4 shadow hover:shadow-xl transition bg-white">
                <img src={product.image} alt={product.name} className="w-full h-64 object-contain" />
                <h2 className="text-xl font-semibold mt-2 text-gray-900">{product.name}</h2>
                <p className="text-gray-500 line-through">Rs. {product.originalPrice}</p>
                <p className="text-lg text-black font-bold">Rs. {product.price}</p>
                <button className="mt-2 bg-black text-white px-4 py-2 rounded">Buy Now</button>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
